// Appended after the effect file
void main()
{
    gl_FragColor = vec4(effect(vUv), 1.0);
}
